angular.module('tasks').directive('userAvatar', ["PATH", function(PATH){
  return {
    restrict: 'E',
    scope: {
      user: '=',
    },
    templateUrl: PATH.components + 'taskManagement/userAvatar/view.html'
  }
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/taskManagement/userAvatar/directive.js